export default __webpack_public_path__ + "static/media/Prysmian_Logo_RGB_Negative.3fa389e9.webp";